'use client';
import { createContext, type ReactNode, useContext } from 'react';
import type { SiteData } from 'src/types';

const SiteDataContext = createContext<SiteData | null>(null);

export const SiteDataProvider = ({
  children,
  siteData,
}: {
  children: ReactNode;
  siteData: SiteData;
}) => {
  return (
    <SiteDataContext.Provider value={siteData}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => {
  const context = useContext(SiteDataContext);
  if (!context) {
    throw new Error('useSiteData must be used within a SiteDataProvider');
  }
  return context;
};

export const useStaticContent = () => {
  const siteData = useSiteData();
  return siteData.static_content;
};
